<form class="modal-form">
  <span class="p-float-label">
    <textarea
      id="actualCardUpdate"
      rows="5"
      cols="80"
      pInputTextarea
      [(ngModel)]="actualCardUpdate"
      name="actualCardUpdate"
      (click)="copyToClipboard(actualCardUpdate)"
      readonly
      required
    ></textarea>
    <label for="actualCardUpdate">Troca do Cartão</label>
  </span>
  <div class="buttons">
    <p-button
      type="button"
      label="Sinalizar como resolvido"
      icon="pi pi-check"
      (onClick)="markAsResolved()"
    />
  </div>
</form>
<p-toast />
